import { StyleSheet } from 'react-native';

export const commonStyles = StyleSheet.create({
  fill: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  fillR: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    flexDirection: 'row',
  },
  f1: {
    flex: 1,
  },
  f1r: {
    flex: 1,
    flexDirection: 'row',
  },
  fr: {
    flexDirection: 'row',
  },
  centeredFill: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  blackCenteredFill: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'black',
  },
  text: {
    fontFamily: 'Inter',
  },
  tabBarStyle: {
    borderTopWidth: 0,
    backgroundColor: 'black',
  },
});
